import { render, staticRenderFns } from "./PicPreview.vue?vue&type=template&id=65ffcfc4&scoped=true&"
import script from "./PicPreview.vue?vue&type=script&lang=js&"
export * from "./PicPreview.vue?vue&type=script&lang=js&"
import style0 from "./PicPreview.vue?vue&type=style&index=0&id=65ffcfc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ffcfc4",
  null
  
)

export default component.exports